import { render } from "./manageIndex.vue?vue&type=template&id=bb217516&scoped=true"
import script from "./manageIndex.vue?vue&type=script&lang=js"
export * from "./manageIndex.vue?vue&type=script&lang=js"

import "./manageIndex.vue?vue&type=style&index=0&id=bb217516&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb217516"]])

export default __exports__